import React, { useEffect } from "react";
import addIcon from "../../../assets/images/icons/add-icon.png";
import UploadJson from "../../../components/modals/UploadJson";
import PlanOverviewModal from "./PlanOverviewModal";
import AllPlanModal from "./AllPlanModal";

const AddNewPlanButton = ({
                            setCurrentModal,
                            currentModal,
                            openModal,
                            modalAddBtn,
                            selectedPlanId,
                            handleFileUpload,
                            handleSubmit,
                            uploadedJson,
                            errorMessage,
                            fileName,
                            onAddNewPlanClick,
                            setSelectedImageUrl,
                            setSelectedVideoUrl,
                            imageUrl,
                            videoUrl,
                            setUploadedJson
                          }) => {
  const closeModal = () => {
    setCurrentModal(null);
  };

  useEffect(() => {
    if (selectedPlanId) {
      openModal(2);
    }
  }, [selectedPlanId]);
  return (
    <div className="w-100">
      <button
        className="btn btn-primary"
        onClick={() => {
          onAddNewPlanClick();
          openModal(1);
        }}
      >
        <img src={addIcon} alt="Add New Plan" />
        <span>{modalAddBtn}</span>
      </button>
      {currentModal === 1 && (
        <UploadJson
          onOpenModal2={() => openModal(2)}
          onClose={closeModal}
          onFileUpload={handleFileUpload}
          fileName={fileName}
          errorMessage={errorMessage}
        />
      )}
      {currentModal === 2 && (
        <PlanOverviewModal
          jsonData={uploadedJson}
          onOpenModal={() => openModal(3)}
          onClose={closeModal}
          setSelectedImageUrl={setSelectedImageUrl}
          setSelectedVideoUrl={setSelectedVideoUrl}
          setUploadedJson={setUploadedJson}
          imageUrl={imageUrl}
          videoUrl={videoUrl}
        />
      )}
      {currentModal === 3 && (
        <AllPlanModal
          jsonData={uploadedJson}
          onOpenModal4={() => openModal(4)}
          onClose={closeModal}
          onSubmit={handleSubmit}
          setUploadedJson={setUploadedJson}
          selectedPlanId={selectedPlanId}
          setSelectedImageUrl={setSelectedImageUrl}
          setSelectedVideoUrl={setSelectedVideoUrl}
          imageUrl={imageUrl}
          videoUrl={videoUrl}
        />
      )}
    </div>
  );
};

export default AddNewPlanButton;
